import React from "react"
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
} from "react-share"

export const SocialShare = ({ link, isAmp }) => {
  return (
    <>
      {isAmp ? (
        <ul className={`social mb-5`}>
          <li className="social-item">
            <amp-social-share
              type="twitter"
              aria-label="Share on Twitter"
              width="35"
              height="35"
            ></amp-social-share>
          </li>
          <li className="social-item">
            <amp-social-share
              type="whatsapp"
              width="35"
              height="35"
            ></amp-social-share>
          </li>
          <li className="social-item">
            <amp-social-share
              type="linkedin"
              aria-label="Share on Linkedin"
              width="35"
              height="35"
            ></amp-social-share>
          </li>
          <li className="social-item">
            <amp-social-share
              type="facebook"
              aria-label="Share on Facebook"
              width="35"
              height="35"
              data-param-app_id={process.env.FB_APP_ID}
            ></amp-social-share>
          </li>
        </ul>
      ) : (
        <ul className={`social mb-5`}>
          <li className="social-item">
            <TwitterShareButton url={link} className="social-link text-dark">
              <i className={`aib ai-twitter`} alt="twitter" />
            </TwitterShareButton>
          </li>
          <li className="social-item">
            <FacebookShareButton url={link} className="social-link text-dark">
              <i className={`aib ai-facebook-square`} alt="facebook" />
            </FacebookShareButton>
          </li>
          <li className="social-item">
            <WhatsappShareButton url={link} className="social-link text-dark">
              <i className={`aib ai-whatsapp`} alt="whatsapp" />
            </WhatsappShareButton>
          </li>
          <li className="social-item">
            <LinkedinShareButton url={link} className="social-link text-dark">
              <i className={`aib ai-linkedin`} alt="linkedin" />
            </LinkedinShareButton>
          </li>
        </ul>
      )}
    </>
  )
}

SocialShare.defaultProps = {
  isAmp: false,
}
